<div class="modal-header">
    <div class="row col-12">        
        <div class="modal-title col-10">
            <h3>Opret databaseskabelon</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true" ><i class="fa-solid fa-x"></i></span>
                </button>    
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row">   
            <form action="">
                <div class="row mb-3">
                    <div class="form-floating col-lg-12 col-12 mb-lg-0 mb-3 mt-3">
                        <select class="form-select" id="db-type" [(ngModel)]="dbTypeInput" name="dbType">
                            @for (type of dbTypes; track $index) {
                            <option [value]="type" [selected]="type == dbTypeInput">{{type}}</option>
                            }
                        </select>
                        <label class="ms-2" for="db-type">Type</label>
                    </div>
                    <div class="form-floating col-lg-12 col-12 mb-lg-0 mb-3 mt-3">
                        <input type="text" class="form-control" id="db-name" [(ngModel)]="dbNameInput" 
                            name="dbName" autocomplete="off" autofocus>
                        <label class="ms-2" for="db-name">Navn</label>
                    </div>
                    <div class="form-floating col-lg-12 col-12 mb-lg-0 mb-3 mt-3">
                        <input type="text" class="form-control" id="db-schema" [(ngModel)]="dbSchemaInput" 
                            name="dbSchema" autocomplete="off" autofocus>
                        <label class="ms-2" for="db-schema">Skema</label>
                    </div>
                </div>
            </form>
    </div>
    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" (click)="createTemplate()" [disabled]="disabled()">
            @if(isCreatingTemplate)
            {
                <div class="spinner-border spinner-border-sm me-2" role="status">
                    <span class="visually-hidden">Opretter...</span>
                </div>
            }                    
            Indlæs og opret</button> 
    </div>
</div>